import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { ContentType } from '@mode/notebooks/contract';
import { CreateDatasetModalComponent } from './create-dataset-modal/create-dataset-modal.component';
import { RenameDatasetModalComponent } from './rename-dataset-modal/rename-dataset-modal.component';

@Injectable()
export class DatasetModalService {
  constructor(private dialogService: DialogService) {}

  public openCreateDatasetModal(cellToken: string, cellContentType: ContentType): void {
    this.dialogService.open({
      component: CreateDatasetModalComponent,
      matDialogConfig: {
        backdropClass: 'cdk-overlay-dark-backdrop',
        data: {
          cellToken,
          cellContentType,
        },
      },
    });
  }

  public openRenameDatasetModal(queryName: string, onSubmit: (datasetName: string) => void): void {
    this.dialogService.open({
      component: RenameDatasetModalComponent,
      matDialogConfig: {
        backdropClass: 'cdk-overlay-dark-backdrop',
        data: {
          queryName,
          onSubmit,
        },
      },
    });
  }
}
